import { useCreditContext } from 'contexts'
import { VaultCardMobile } from './VaultCardMobile'

export const VaultsListMobile = () => {
  const { coreCapsules } = useCreditContext()

  const getMobileVaultCards = () => {
    const sortedCoreCapsules = Array.from(coreCapsules.values()).sort(
      (a, b) =>
        parseInt(a.creditLimitAttributes.threshold || '0') -
        parseInt(b.creditLimitAttributes.threshold || '0'),
    )

    return sortedCoreCapsules.map((coreCapsule, i) => (
      <VaultCardMobile key={i} coreCapsule={coreCapsule} />
    ))
  }

  return <>{coreCapsules.size > 0 ? getMobileVaultCards() : <VaultCardMobile />}</>
}
